var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulletList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z",
    fill: "#2F3032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H8C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8H20Z",
    fill: "#2F3032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H20Z",
    fill: "#2F3032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17C21 17.5523 20.5523 18 20 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H20C20.5523 16 21 16.4477 21 17Z",
    fill: "#2F3032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12Z",
    fill: "#2F3032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4.55228 18 5 17.5523 5 17C5 16.4477 4.55228 16 4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18Z",
    fill: "#2F3032"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default __webpack_public_path__ + "static/media/BulletList.0461e9fec9047e409c8d42d8466f8de3.svg";
export { ForwardRef as ReactComponent };